import React, { useState } from 'react';
import RiskEntitiesBarGraph from './RiskEntitiesBarGraph';
import useGetRiskEntitiesOverview from '../api/queries/risk-entities/useGetRiskEntitiesOverview';
import RiskBarLegend from './RiskBarLegend';
import { IconButton, IconButtonStyles, Icons } from '@silverfort/sf-components';
import RiskEntitiesPopup from './RiskEntitiesPopup/RiskEntitiesPopup';

const RiskEntitiesOverview = () => {
    const [isEntitiesPopupOpen, setIsEntitiesPopupOpen] = useState(false);

    const { data, isFetching } = useGetRiskEntitiesOverview();

    return (
        <>
            <div className="relative h-full w-full">
                <div className="h-full w-full flex flex-col justify-between rounded-lg border">
                    <div className="h-12 border-b flex items-center px-4 py-2 flex-none">
                        <div className="text-13 font-medium font-sf">Entities by Risk</div>
                    </div>
                    <div className="flex flex-col flex-1 pt-4 px-6 gap-2">
                        {data && !isFetching && (
                            <>
                                <div className="h-fit">
                                    <RiskEntitiesBarGraph riskEntitiesOverview={data} />
                                </div>
                                <RiskBarLegend riskEntitiesOverview={data} />
                            </>
                        )}
                    </div>
                </div>
                <IconButton
                    icon={Icons.Expand}
                    buttonStyle={IconButtonStyles.Secondary}
                    onClick={() => setIsEntitiesPopupOpen(true)}
                    className="absolute top-4 right-4 hover:bg-sf-gray-100 hover:rounded"
                />
            </div>
            <RiskEntitiesPopup open={isEntitiesPopupOpen} onClose={() => setIsEntitiesPopupOpen(false)} />
        </>
    );
};

export default RiskEntitiesOverview;
